export default __webpack_public_path__ + "static/media/5134.96c61990.png";